module.exports = __webpack_public_path__ + "img/app/home/img/icon-sliver.b9bf1dc77186816ca8dde4245fb07e6e.png";